<!-- Menu de secciones -->
<div class="row mb-2 justify-content-center" *ngIf="menu.color" style="min-height: auto;"
  [ngStyle]="{'background': menu.color, 'background-image': 'url(' + menu.background + ')'}">
  <!-- Items de secciones de galeria de imagenes -->
  <app-item-gallery [section]="menu.sections[0]" *ngIf="menu.sections[0]?.type === TYPE_SECTIONS.gallery"></app-item-gallery>
  <div class="col-12 mb-2 pb-2 pt-2 pl-3 pr-3 cursor animate__animated fadeIn animate__delay-1s" *ngFor="let section of menu.sections; let index = index"
    [id]="section.name + 'section'" [hidden]="(section.type === TYPE_SECTIONS.additions || section.type === TYPE_SECTIONS.gallery)">
    <!-- Nombre de la seccion -->
    <div class="row" (click)="selectSection(section)">
      <div class="col-12 rounded" *ngIf="!section.photo && section.type !== 'gallery'" [ngStyle]="{'background': menu.colorText}" [id]="section.photo">
        <h1 class="meal-title font-weight-bold {{menu.fontHeader}} p-4 justify-content-center" [ngStyle]="{'color': menu.color}" translate="no">
          <ng-container *ngIf="language === 'ES'">
            {{ section.name | uppercase }}
          </ng-container>
          <ng-container *ngIf="language === 'EN'">
            {{ section.nameEn | uppercase }}
          </ng-container>
        </h1>
      </div>
      <!-- Foto de la seccion  con texto puesto por eazzy-->
      <div class="col-12 align-items-center justify-content-center d-flex" *ngIf="section.photo && section.text">
        <h1 class="{{menu.fontHeader}} font-weight-bold position-absolute section-name" style="color: white; z-index:1" translate="no">
          {{ language === 'ES'? section.name: section.nameEn}}</h1>
        <img [src]="noImage" [alt]="isInViewport(section, section.photo)" [id]="section.photo" class="img-fluid animate__animated rounded" style="width: 100%;">
      </div>
      <!-- Foto de la seccion sin texto-->
      <div class="col-12" *ngIf="section.photo && !section.text">
        <img [src]="noImage" [alt]="isInViewport(section, section.photo)" [id]="section.photo" class="img-fluid animate__animated rounded" style="width: 100%;">
      </div>
    </div>

    <!-- Secciones -->
    <div class="row body justify-content-center backgrounds fadeIn animate__animated" [ngStyle]="{'background': 'transparent'}"
      *ngIf="selectedSection && (selectedSection.name === section.name)">

      <!-- Items de secciones con foto -->
      <app-item-image [section]="selectedSection" [menu]="menu" class="w-100"
        *ngIf="section.type === TYPE_SECTIONS.productsMenu|| section.type === TYPE_SECTIONS.productsOnlyPhoto">
      </app-item-image>

      <!-- Items de secciones con o sin logo en modo listado -->
      <app-item-list *ngIf="section.type === TYPE_SECTIONS.productList" [section]="selectedSection" [menu]="menu" class="w-100">
      </app-item-list>


      <!-- Items de secciones en modo listado simple -->
      <app-item-simple-list *ngIf="section.type === TYPE_SECTIONS.productSimpleList" [section]="selectedSection" [menu]="menu" class="w-100">
      </app-item-simple-list>

      <!-- Items de secciones de bebidas alcoholicas -->
      <app-item-drinks *ngIf="section.type === TYPE_SECTIONS.drinks || section.type === TYPE_SECTIONS.wines" [section]="selectedSection" [menu]="menu" class="w-100">
      </app-item-drinks>
      <!-- Items de secciones de listado solo con descripciones -->
      <app-item-only-description [section]="section" [menu]="menu" *ngIf="section.type === TYPE_SECTIONS.onlyDescription" class="w-100"></app-item-only-description>
      <!-- Items de secciones de bebidas alcoholicas -->
      <app-item-drink-midle *ngIf="section.type === TYPE_SECTIONS.drinks_midle" [section]="selectedSection" [menu]="menu" class="w-100">
      </app-item-drink-midle>
      <!-- Items de secciones de galeria de imagenes -->
      <app-item-gallery [section]="selectedSection" *ngIf="section.type === TYPE_SECTIONS.gallery"></app-item-gallery>
      <!-- Items de secciones de adiciones -->
      <app-item-list-additions *ngIf="menu.sections[index + 1]?.type === TYPE_SECTIONS.additions" [section]="menu.sections[index + 1]" [menu]="menu" class="w-100">
      </app-item-list-additions>
      <!-- Items de secciones de galeria de imagenes -->
      <app-item-gallery [section]="menu.sections[index + 1]" *ngIf="menu.sections[index + 1]?.type === TYPE_SECTIONS.gallery"></app-item-gallery>
      <!-- Descripcion de la seccion -->
      <div class="justify-content-center text-center d-flex text-center p-1" *ngIf="section.description">
        <p [ngStyle]="{'color': menu.colorText}" class="mb-4 {{menu.fontText}} font-weight-bold">
          {{ language === 'ES'? section.description: section.descriptionEn }}
        </p>
      </div>
    </div>
  </div>
</div>
<div class="row mb-7">
  <div class="col-12">
    <app-menu-selectors [menu]="menu"></app-menu-selectors>
  </div>
</div>